import { t } from '@/i18n';
import { Button, ButtonProps, forwardRef, Icon } from '@chakra-ui/react';
import { ArrowPathIcon } from '@heroicons/react/24/outline';

export const UpdateListButton = forwardRef<ButtonProps, 'button'>((props, ref) => (
  <Button variant='link' color='brand.500' leftIcon={<Icon as={ArrowPathIcon} />} {...props} ref={ref}>
    {t('components.table_simple_controls.update_button_list')}
  </Button>
));
